export default [
  // Consultations
  {
    path: "/patients-consultations",
    name: "patients-consultations",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/ConsultationsView.vue"
      ),
    props: true,
    meta: {
      activeIcon: "Consultations",
      routeName: "Consultations",
    },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id",
    name: "patients-consultation-view",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/ConsultationInformationView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Consultation Details",
    },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id/form",
    name: "patients-add-consultation-form",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/form/ConsultationFormView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      userRole: "DOCTOR",
      action: "add",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Add Consultation Form",
    },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id/form/2",
    name: "patients-consultation-form-continuation",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/form/ConsultationFormContinuation.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      userRole: "DOCTOR",
      action: "add",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Add Consultation Form",
    },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id/edit-form/:consultation_form_id",
    name: "patients-edit-consultation-form",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/form/ConsultationFormView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      consultation_form_id: String(route.params.consultation_form_id),
      userRole: "DOCTOR",
      action: "edit",
    }),
    meta: { activeIcon: "Consultations", routeName: "Edit Consultation Form" },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id/edit-form/:consultation_form_id/continuation",
    name: "patients-edit-consultation-form-continuation",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/form/ConsultationFormContinuation.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      consultation_form_id: String(route.params.consultation_form_id),
      userRole: "DOCTOR",
      action: "edit",
    }),
    meta: { activeIcon: "Consultations", routeName: "Edit Consultation Form" },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id/files",
    name: "patients-consultation-files",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/ConsultationFilesView.vue"
      ),
    props: (route) => ({
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Consultation Files",
    },
  },
  {
    path: "/patients-consultations/:consultation_id/view/:hospital_service_id/files/viewer",
    name: "patients-consultation-files-view",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/FileView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Consultation Files",
    },
  },

  // DIALYSIS
  {
    path: "/patients-dialysis",
    name: "patients-dialysis",
    component: () => import("@/views/dialysis/DialysisView.vue"),
    meta: {
      activeIcon: "Dialysis",
      routeName: "Citizens' Dialysis",
    },
  },
  {
    path: "/patients-dialysis/session/:id",
    name: "patients-dialysis-session",
    component: () =>
      import(
        /* webpackChunkName: "dialysis" */ "@/views/dialysis/DialysisSessionView.vue"
      ),
    props: true,
    meta: {
      activeIcon: "Dialysis",
      routeName: "Citizens's Dialysis Session",
    },
  },
  {
    path: "/patients-dialysis/session/:id/files/:hospital_service_id",
    name: "patients-dialysis-files",
    component: () =>
      import(
        /* webpackChunkName: "dialysis" */ "@/views/dialysis/DialysisFilesView.vue"
      ),
    props: (route) => ({
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Dialysis",
      routeName: "Citizens's Dialysis Session Files",
    },
  },
  {
    path: "/patients-dialysis/session/:id/files/:hospital_service_id/viewer",
    name: "patients-dialysis-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Dialysis",
      routeName: "Dialysis Session File Viewer",
    },
  },

  // DIAGNOSTICS
  {
    path: "/patients-diagnostics",
    name: "patients-diagnostics",
    component: () => import("@/views/diagnostics/DiagnosticsView.vue"),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Citizens' Diagnostics",
    },
  },
  {
    path: "/patients-diagnostics/:id",
    name: "patients-diagnostic-details",
    component: () =>
      import(
        /* webpackChunkName: "diagnostics" */ "@/views/diagnostics/DiagnosticInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Citizen's Diagnostic Information",
    },
  },
  {
    path: "/patients-diagnostics/:id/files/:hospital_service_id",
    name: "patients-diagnostic-files",
    component: () =>
      import(
        /* webpackChunkName: "diagnostics" */ "@/views/diagnostics/DiagnosticFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Citizen's Diagnostic Files",
    },
  },
  {
    path: "/patients-diagnostics/:id/files/:hospital_service_id/viewer",
    name: "patients-diagnostic-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Diagnostic File Viewer",
    },
  },

  // LABORATORIES
  {
    path: "/patients-laboratories",
    name: "patients-laboratories",
    component: () => import("@/views/laboratories/LaboratoriesView.vue"),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Citizens' Laboratories",
    },
  },
  {
    path: "/patients-laboratories/:id",
    name: "patients-laboratory-details",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/laboratories/LaboratoryInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Citizen's Laboratory",
    },
  },
  {
    path: "/patients-laboratories/:id/files/:hospital_service_id",
    name: "patients-laboratory-files",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/laboratories/LaboratoryFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Citizen's Laboratory Files",
    },
  },
  {
    path: "/patients-laboratories/:id/files/:hospital_service_id/viewer",
    name: "patients-laboratory-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Laboratory File Viewer",
    },
  },

  // GENERAL SERVICES
  {
    path: "/patients-general-services",
    name: "patients-general-services",
    component: () => import("@/views/general-services/GeneralServicesView.vue"),
    meta: {
      activeIcon: "General Services",
      routeName: "Citizens' General Services",
    },
  },
  {
    path: "/patients-general-services/:id",
    name: "patients-general-services-details",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/general-services/GeneralServiceInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "Citizen's General Service",
    },
  },
  {
    path: "/patients-general-services/:id/files/:hospital_service_id",
    name: "patients-general-services-files",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/general-services/GeneralServiceFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "Citizen's General Service Files",
    },
  },
  {
    path: "/patients-general-services/:id/files/:hospital_service_id/viewer",
    name: "patients-general-services-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "General Service File Viewer",
    },
  },
];
